import React from 'react';
import { Button, Modal, ModalProps } from 'antd';

interface IModalProps {
	actions?: {
		title: string;
		action: () => void;
		type?: 'default' | 'link' | 'text' | 'primary' | 'dashed';
	htmlType?: 'button' | 'submit' | 'reset';
	}[];
	
}

const ModalComponent: React.FC<IModalProps & ModalProps> = ({
	actions,
	children,
	...props
}) => {
	return (
		<Modal
			{...props}
			footer={(actions || []).map((action) => (
				<Button
					htmlType={action.htmlType}
					key={action.title}
					type={action.type}
					onClick={action.action}
				>
					{action.title}
				</Button>
			))}
		>
			{children}
		</Modal>
	);
};

export default ModalComponent;
